/* Translate the app-owned heading inside this theme preview; never alter review content. */
(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('fr')) return;
  let queued=false;
  function translate(){
    queued=false;
    document.querySelectorAll('.jdgm-title').forEach(heading=>{
      if(heading.textContent.trim()==='Customers are saying') heading.textContent='Les avis sur Arcanis';
    });
  }
  translate();
  new MutationObserver(records=>{
    if(queued||!records.some(record=>record.addedNodes.length)) return;
    queued=true;requestAnimationFrame(translate);
  }).observe(document.body,{childList:true,subtree:true});
})();
